import { lazy } from "react";
import Loadable from "../Loadable";
import AdminLayout from "components/layouts/adminLayout";
import AuthGuard from "../AuthGuard";

import ChangePassword from "pages/auth/ChangePassword";
const Dashboard = Loadable(lazy(() => import("pages/admin/dashboard")));
const DebitCreditReport = Loadable(lazy(() => import("pages/admin/dashboard/report/DebitCreditReport")));

const Profile = Loadable(lazy(() => import("pages/admin/Profile")));
const CreateAdminList = Loadable(lazy(() => import("pages/auth/CreateAdmin")));
const AdminList = Loadable(lazy(() => import("pages/admin")));

const AdminRoutes = {
  element: (
    <AuthGuard>
      <AdminLayout />
    </AuthGuard>
  ),
  children: [
    {
      path: "admin/list",
      element: <AdminList />,
    },
    {
      path: "admin/create-admin",
      element: <CreateAdminList />,
    },
    {
      path: "admin/dashboard",
      element: <Dashboard />,
    },
    {
      path: "admin/dashboard/debit-credit-report",
      element: <DebitCreditReport />,
    },
    {
      path: "admin/profile",
      element: <Profile />,
    },
    {
      path: "auth/change-password",
      element: <ChangePassword />,
    },
  ],
};

export default AdminRoutes;
